// extracted by mini-css-extract-plugin
module.exports = {"first_time_mover":"_24WA4ddUAGulwtrtExVP7J","first_time_mover_icon":"_2_z8Id8z0ev71Ncd0VdoKM","item":"_1hbvHyUY2oZLgXRPxD6FAr"};